import { useGroupStorage } from '../../../../../../AppClients';
import { getAccountDisplayName } from '../../../../../../backend/features/accounts/shared';
import { groupAccountMapEntityName, groupEntityName } from '../../../../../../backend/features/groups/shared';
import { getGroupFilter } from '../../../../../../backend/features/permissions/shared';
import { showGroupsDialog } from '../../../../../../ui/features/groups/components/GroupsPanel/components/GroupsDialog';
import { useUserState } from '../../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Box, Button, CircularProgress, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react';
const AccountGroupUserComponent = (props, ref) => {
    const userState = useUserState();
    const { t } = useContactManagementTranslation();
    const { data: groups, isLoading, mutate, } = useStorageList(groupEntityName, {
        filter: [
            ...getGroupFilter(userState),
            { column: 'filterBased', op: '=', value: false },
            {
                relationEntity: groupAccountMapEntityName,
                relationColumn: 'groupId',
                filter: [{ column: 'accountId', op: '=', value: props.accountId }],
            },
        ],
        orderBy: [{ column: 'name' }],
    });
    const groupStorage = useGroupStorage();
    React.useImperativeHandle(ref, () => ({
        submit: () => Promise.resolve(),
        getData: () => ({}),
    }));
    const handleAddGroup = () => {
        const accountId = props.accountId;
        if (accountId) {
            showGroupsDialog({
                excludeFilterBasedGroups: true,
                onSelect: (selectedGroupId) => {
                    groupStorage
                        .addAccountsToGroup(selectedGroupId, [accountId])
                        .then(() => mutate())
                        .catch(handleErrorDialog);
                },
            });
        }
    };
    const handleRemoveGroup = (groupId) => {
        const accountId = props.accountId;
        if (accountId && props.data) {
            showConfirmDialog({
                title: t('forms.accountGroupUser.removeDialogTitle'),
                content: t('forms.accountGroupUser.removeDialogMessage', { accountDisplayName: getAccountDisplayName(props.data) }),
                onConfirm: () => {
                    groupStorage
                        .removeAccountsFromGroup(groupId, [accountId])
                        .then(() => mutate())
                        .catch(handleErrorDialog);
                },
            });
        }
    };
    return (React.createElement(Box, null,
        groups && (React.createElement(Paper, { sx: { p: 2, display: 'flex', flexDirection: 'column', gap: 1 }, variant: 'outlined' },
            React.createElement(Box, { sx: { pb: 2, display: 'flex', alignItems: 'center', gap: 2 } },
                React.createElement(Typography, { sx: { flexGrow: 1 }, variant: 'subtitle1' }, t('forms.accountGroupUser.groups')),
                React.createElement(Button, { startIcon: React.createElement(AddIcon, null), color: 'primary', onClick: handleAddGroup }, t('forms.accountGroupUser.addGroup'))),
            groups.rows.map((group) => (React.createElement(Box, { key: group.id, sx: {
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    backgroundColor: themeColors.surface.secondary,
                    borderRadius: 1,
                } },
                React.createElement(Typography, { sx: { flexGrow: 1 }, variant: 'subtitle2' }, group.columns.name),
                React.createElement(Tooltip, { title: t('forms.accountGroupUser.removeGroup') },
                    React.createElement(IconButton, { color: 'primary', onClick: () => handleRemoveGroup(group.id) },
                        React.createElement(DeleteOutlinedIcon, null)))))),
            groups.rows.length === 0 && (React.createElement(Typography, { sx: { pt: 2, color: themeColors.text.subtle }, variant: 'body2' }, t('forms.accountGroupUser.noGroupsMessage'))))),
        !groups && isLoading && React.createElement(CircularProgress, null)));
};
export const AccountGroupUser = React.forwardRef(AccountGroupUserComponent);
